import React, { useState } from "react";

export const ProjectPermanenceCard: React.FC = () => {
  const [hoveredProject, setHoveredProject] = useState<string | null>(null);

  const projects = [
    { name: "Mineralised CO2", timeframe: "1000+", x: 95, y: 95, risk: "permanent" },
    { name: "Bio-oil underground", timeframe: "1000+", x: 90, y: 90, risk: "permanent" },
    {
      name: "Geological storage of liquid CO2",
      timeframe: "1000+",
      x: 85,
      y: 85,
      risk: "permanent",
    },
    { name: "Biomass burial", timeframe: "100+", x: 75, y: 60, risk: "low" },
    { name: "Deep sea storage of CO2", timeframe: "1000+", x: 30, y: 85, risk: "high" },
    { name: "Biochar in soil", timeframe: "1000+", x: 25, y: 85, risk: "high" },
    { name: "Coastal blue carbon", timeframe: "50-80", x: 45, y: 40, risk: "high" },
    { name: "Forestry", timeframe: "50-80", x: 40, y: 35, risk: "high" },
    { name: "Soil carbon", timeframe: "10-50", x: 35, y: 25, risk: "high" },
    { name: "Deferred timber harvests", timeframe: "1-10", x: 10, y: 10, risk: "all" },
  ];

  const timeScales = ["1000+ years", "100 years", "10 years", "1 year"];
  const riskLevels = ["All CO2 released", "High risk", "Low risk", "Permanent"];

  return (
    <div className="rounded-lg bg-white p-6 shadow-md">
      <h3 className="mb-6 text-lg font-medium">Carbon Storage Permanence</h3>
      <div className="relative h-[600px]">
        {/* Y-axis labels */}
        <div className="absolute left-0 flex h-full flex-col justify-between text-sm font-medium">
          {timeScales.map((scale) => (
            <div key={scale} className="-translate-y-1/2 transform">
              {scale}
            </div>
          ))}
        </div>

        {/* Graph area */}
        <div className="absolute bottom-8 left-24 right-8 top-4 border-b border-l border-gray-300">
          {/* Project dots */}
          {projects.map((project) => (
            <div
              key={project.name}
              className={`absolute -translate-x-1/2 -translate-y-1/2 transform transition-all duration-200`}
              style={{
                left: `${project.x}%`,
                top: `${100 - project.y}%`,
              }}
              onMouseEnter={() => setHoveredProject(project.name)}
              onMouseLeave={() => setHoveredProject(null)}
            >
              <div
                className={`
                  whitespace-nowrap rounded-full px-4 py-2
                  ${
                    hoveredProject === project.name
                      ? "bg-primary scale-110 text-white"
                      : "bg-gray-100 hover:bg-gray-200"
                  }
                  cursor-pointer transition-all duration-200
                `}
              >
                <span className="font-medium">{project.name}</span>
                <span className="ml-2 text-xs opacity-75">{project.timeframe} years</span>
              </div>
            </div>
          ))}
        </div>

        {/* X-axis labels */}
        <div className="absolute bottom-0 left-24 right-8 flex justify-between text-sm font-medium">
          {riskLevels.map((level) => (
            <div key={level} className="translate-y-6 transform text-center">
              {level}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
